module.exports = __webpack_public_path__ + "img/apple_pay.415bf6c9.svg";